import { render, staticRenderFns } from "./CelebBox.vue?vue&type=template&id=15109bbe&scoped=true"
import script from "./CelebBox.vue?vue&type=script&lang=js"
export * from "./CelebBox.vue?vue&type=script&lang=js"
import style0 from "./CelebBox.vue?vue&type=style&index=0&id=15109bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15109bbe",
  null
  
)

export default component.exports